window?.addEventListener('DOMContentLoaded', function () {
  const columnsSliderSections = document?.querySelectorAll('.columns-slider');

  columnsSliderSections?.forEach((item) => {
    const sliderEl = item?.querySelector('.keen-slider');

    if (sliderEl) {
      const slider = new KeenSlider(sliderEl, {
        breakpoints: {
          '(max-width: 1400px)': {
            slides: { perView: 3, spacing: 10 },
          },
          '(max-width: 1280px)': {
            slides: { perView: 3, spacing: 10 },
          },
          '(max-width: 1024px)': {
            slides: { perView: 2, spacing: 10 },
          },
          '(max-width: 640px)': {
            slides: { perView: 1, spacing: 10 },
          },
        },
        slides: {
          perView: 3,
          spacing: 32,
        },

        slideChanged(e) {
          updateDots();
        },
      });
      const dotsContainer = item?.querySelector('.dots-container');
      let dots = [];

      function createDots() {
        if (!dotsContainer) return;
        const slidesCount = slider?.track?.details?.slides?.length;
        dotsContainer.innerHTML = '';
        for (let i = 0; i <= slidesCount - 1; i++) {
          const dot = document.createElement('button');
          dot.className = 'dot';
          dot.setAttribute('aria-label', 'dot');
          dot.addEventListener('click', () => slider.moveToIdx(i));
          dotsContainer.appendChild(dot);
          dots.push(dot);
        }
        updateDots();
      }

      function updateDots() {
        if (!dots?.length) return;
        const currentIdx = slider?.track?.details?.rel;
        dots.forEach((dot, idx) => {
          dot?.classList?.toggle('active', idx === currentIdx);
        });
      }

      createDots();
    }
  });
});
